import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemGetRtspPerm';
import RTSPConfigTable from 'components/Web_User_Interface/1440p_Series/Network/RTSP/rtspConfigTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Netzwerk Menü // RTSP",
  "path": "/Web_User_Interface/1440p_Serie/Netzwerk/RTSP/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Der RTSP-Port ist der RTSP-Streaming-Port der Kamera.",
  "image": "./WebUI_1440p_SearchThumb_Network_IP_Configuration.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Netzwerk Menü // RTSP' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Der RTSP-Port ist der RTSP-Streaming-Port der Kamera.' image='/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Network/IP_Configuration/' locationFR='/fr/Web_User_Interface/1440p_Series/Network/IP_Configuration/' crumbLabel="RTSP" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "netzwerk-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#netzwerk-men%C3%BC",
        "aria-label": "netzwerk menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Netzwerk Menü`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/e2e58/1440p_Settings_Network_RTSP.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.82608695652174%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACNElEQVQoz3WRS0tUYQCG/RduZZC5HYWg5nLGOZc5c3Nm1DnfmTO34wUrayxMaREurEbBFi4MDcpwkUFaokJB6EJMKKiFOxf+nqfm6DgEtXh438X3Pbx8X5ckSUh9fQR8vYRTZXJzmyhTa8T/w8DdNYzpV+RmN+iX0wxmUng8Hrq7u+np6aErGAwiSX14ez2ow+PcW/lKvblHrbnfYbHTq819RpufmFw+QMnVUOMK/f03CPiDBANSWyjh8/mIhm5SEQWqV9Ssy6yIPFWXAlWrQKXmIKwS5rCNrqbRtRRGIkMkHPtbKMsxanWHat2h5oy6XZRs97IolRGWjRAlzJmXmI0lqoUy+UwGI5FAU5OEbkXpct+wvTAapV6vY9s2lmVRKlluWsJEjOSxRvIMC5OwEkNNaMzdsRlzkiR0DVVJEgnLnYVerxdZlq+FQohrmVVxKDcWsKaf0TDLzMU1bhtZZh8MUbfj6KqOoRvI0Sthi9bCSCRCsVh0MU1xKRUjiLKD1Vik2FjkcXmMdbvC80qd108fMWGl0FSVwVSCaCTaEQYCAfx+v9sHYiq6liSXzZJOJVDiOk8eOqwuL/Bud4+jb4d8Pz7iYnubecdEVRXShkEo9A9hK1tCTTVQFINcOs38zBRHOxvsfNjm/PyMs8Ndfn3Z5/Rgh5X7JQoZzT0fDl99SlvWFsZkFV01GDezLDUsTjYWuDg94MfxIZ+33rC1vsrJ+7f8/LjJi8khJuw0iqIT/rPwN60jiN+0HhsIAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f5cf014e2ee2eca890a9c1ebef97140f/e4706/1440p_Settings_Network_RTSP.avif 230w", "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/d1af7/1440p_Settings_Network_RTSP.avif 460w", "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/7f308/1440p_Settings_Network_RTSP.avif 920w", "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/c986f/1440p_Settings_Network_RTSP.avif 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/f5cf014e2ee2eca890a9c1ebef97140f/a0b58/1440p_Settings_Network_RTSP.webp 230w", "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/bc10c/1440p_Settings_Network_RTSP.webp 460w", "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/966d8/1440p_Settings_Network_RTSP.webp 920w", "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/b8544/1440p_Settings_Network_RTSP.webp 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f5cf014e2ee2eca890a9c1ebef97140f/81c8e/1440p_Settings_Network_RTSP.png 230w", "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/08a84/1440p_Settings_Network_RTSP.png 460w", "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/c0255/1440p_Settings_Network_RTSP.png 920w", "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/e2e58/1440p_Settings_Network_RTSP.png 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/f5cf014e2ee2eca890a9c1ebef97140f/c0255/1440p_Settings_Network_RTSP.png",
              "alt": "Web User Interface - 1440p Series - Network RTSP Configuration",
              "title": "Web User Interface - 1440p Series - Network RTSP Configuration",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "rtsp-konfiguration",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#rtsp-konfiguration",
        "aria-label": "rtsp konfiguration permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`RTSP Konfiguration`}</h3>
    <p>{`Informationen zum RTSP Port finden Sie unter `}<a parentName="p" {...{
        "href": "/de/Aussenkameras/IN-9408_WQHD/Video_Streaming/"
      }}>{`RTSP Streaming`}</a>{` . Beachten Sie bitte, dass Sie den `}<a parentName="p" {...{
        "href": "/de/Software/Mobile_Apps_HTTPS_and_RTSP/"
      }}>{`RTSP Port in Ihrem Router durchleiten müssen`}</a>{`, wenn Sie den RTSP Stream über Ihre DDNS Adresse abgreifen möchten.`}</p>
    <p>{`Der RTSP-Port wird regulär jedoch nicht benötigt, wenn Sie nur mit unserer Smartphone-App auf Ihre Kamera zugreifen!`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <RTSPConfigTable mdxType="RTSPConfigTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      